<template>
  <div>
    <v-layout wrap justify-center align-center mb-5 class="contenidoCurso">
      <v-flex xs11 sm9 md9 mt-4 :class="`animated dura-1 zoomIn`">
        <p>
          La ruta de aprendizaje está estructurada en tres módulos con los siguientes temas:
        </p>
      </v-flex>
      <v-flex xs11 sm9 md10 mt-2>
          <v-layout row wrap 
                    justify-center
                    align-center
                    v-for="(elemento, idx) in contenido" :key="idx"
                    mt-5 mb-5
                    :class="`animated dura-${idx+2} zoomIn`"
            >
            <v-flex xs6 sm3 md2 mr-2  class="contenedor-contenido-img-padre">
              <div class="contenedor-contenido-img">
                <img :src="require('@/assets/unidad1/mod2/slide 4-'+(idx+1)+'.png')" alt="">
              </div>
            </v-flex>
            <v-flex xs12 sm9 md9>
              <div :class="['contenido-padre', `contenido-padre-${idx+1}`]">
                <div :class="[`contenido-titulo-${idx+1}`]">
                  <h4>Módulo {{idx+1}}: {{elemento.titulo}}</h4>
                </div>
                <div class="lista-contenido">
                  <ul>
                    <li v-for="(el, i) in elemento.subtemas" :key="`Tema${idx}-sub${i}`">
                      <span>{{el}} </span>
                    </li>
                  </ul>
                </div>
              </div>
            </v-flex>
          </v-layout>
      </v-flex>
      <!-- <v-flex xs11 sm9 md10 mt-4 mb-2
                    :class="`animated dura-4 zoomIn`">
          <dialogos-app :dialogos="dialogos" personaje="2">
            <template slot="contentDialog">
                <div class="header-titulo-btn">
                  <button @click="activarMenu()">
                      <div class="menu-header">
                          <menu-app/>
                      </div>
                  </button>  
              </div>
            </template>
          </dialogos-app>
      </v-flex> -->
      <v-flex xs11 sm9 md10 mt-2 mb-5 class="text-xs-center">
        <div class="btn-mod">
          <h2 @click="avanzar()">Puedes cerrar esta ventana para continuar</h2>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  components:{
      MenuApp: () => import('../../components/svg/menu')
  },
  data() {
    return {
      dialogos:[
        `Podrás consultar el menú de contenidos de la ruta de aprenziaje haciendo clic en el siguiente símbolo ubicado en la parte superior izquierda de la pantalla.`
      ],
      contenido:[
        {
          titulo:'Generalidades de la Gestión de Crisis y Continuidad',
          img:'',
          subtemas:[
            `Objetivos`,
            `Conceptos básicos`,
            `Beneficios`,
            `Sistema de Gestión de Crisis y Continuidad del Negocio`,
            `Ciclo de Gestión de Crisis`,
            `¿Qué es resiliencia?`,
            `Actividad`,
            `Elementos claves`,
          ]
        },
        {
          titulo:'Estructura de Respuesta Articulada en Ecopetrol',
          img:'',
          subtemas:[
            "Estructura de Respuesta Articulada",
            "Flujo de activaciones",
            "Equipo Manejo de Incidentes",
            "Equipo de Soporte al Negocio",
            "Sala Situacional Regional",
            "Comité de Crisis Empresarial",
          ]
        },
        {
          titulo:'Aplicación de la estructura de respuesta en Gestión de Crisis y Continuidad del Negocio',
          img:'',
          subtemas:[
            'Resumen de respuesta articulada',
            'Caso de Gestión de Crisis y Continuidad del Negocio',
            'Evaluación',
          ]
        },
      ]
    }
  },
  created(){
    setTimeout(() => {
      this.$store.commit('scrollShow', true)
      this.$store.commit('nextShow', false)
      
    }, 30);
  },
  methods:{
    // activarMenu(){
    //   this.$store.commit('menuStateAmpliar', true)
    // }
  },
  mounted() {
    this.$store.commit("subTemaName", "Estructura de la ruta de aprendizaje")
    var routeArr = this.$route.path.split("/");
    var pageNum = routeArr[routeArr.length - 1];
    
    if (pageNum == 1) {
      setTimeout(() => {
        this.$store.commit('nextShow', false)
      }, 40);
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../../sass/globals';


.btn-mod{
  padding: 10px 18px 10px 18px;
  width: 18rem;
  background: #a65682;
  border-radius: 1rem;
  margin: 0 auto;
  h2{
    text-align: center;
    font-size: 1.5rem;
    font-family: FontBase-Italic;
    color: #fff;
    line-height: 1.7rem;
  }
}

.contenidoCurso{
  //height: 100vh;
  margin-top: 50px;
}
h1{
  font-family: FontBase-Bold;
  font-size: 1.9rem;
}
h2{
  font-size: 1.7rem;
  font-family: FontBase-SemiBold;
  color: $color-primary;
  text-align: left;
  line-height: 1.1em;
}
p{
  font-size: 1.2rem;
  font-family: FontBase-Regular;
}

.header-titulo-btn{
  display: flex;
  justify-content: center;
  button{
    background: #fff;
    border-radius: 10%;
    padding:5px;
    height: 50px;
    width: 50px;
  }
  
}

.contenido-padre{
  border: 2px solid red;
}
h4{
  padding: 10px;
}

.contenido-padre-1,.contenido-titulo-1{border-color: $color-secondary;}
.contenido-padre-2,.contenido-titulo-2{border-color: $color-primary;}
.contenido-padre-3{border-color: $color-complement-one;}
.contenido-titulo-1{
  background: $color-secondary;
  color:#ffffff;
}
.contenido-titulo-2{
  background: $color-primary;
  color:#FFFFFF;
}
.contenido-titulo-3{
  background: $color-complement-one;
  color:#070707;
}
.contenedor-contenido-img-padre{
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.contenedor-contenido-img{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
